<template>
    <div class="create">
        <grid-single-column>
            <div class="create__content">
                <create-content></create-content>
            </div>
        </grid-single-column>
    </div>
</template>
<script>
import createContent from "@/components/create/create-content"
export default {
    metaInfo() {
        return {
            title: "Create post"
        }
    },

    components: {
        'create-content': createContent
    }
}
</script>